import { useMemo } from "react";
import store from "../store";

function compareNames(a, b) {
  return a.toLowerCase().trim() === b.toLowerCase().trim();
}

export function validateNotEmpty(value) {
  if (!Boolean(value)) {
    return "A valid value is required";
  }
}

export function validateDonationAmount(value) {
  const regex = /^[0-9]+(\.[0-9]{1,2})?$/;

  if (!Boolean(regex.test(value))) {
    return "Needs to be a valid dollar amount.";
  }

  const amount = parseFloat(value);
  if (amount === 0 || isNaN(amount)) {
    return "The donation amount cannot be zero.";
  }
}

export function validateTeamName(value, state) {
  const teamExists = state.teams.teamsData.some((team) =>
    compareNames(team.team_name, value)
  );

  if (teamExists) {
    return `The team ${value} already exists. Please enter a different name to be created.`;
  }

  if (value.length > 20) {
    return "The team name can be 20 characters or less.";
  }
}

export function validateForm(form, validators) {
  const validation = {};
  const state = store.getState();
  const fields = Object.keys(form);

  fields.forEach((field) => {
    const value = form[field];
    const functions = validators[field];

    for (let i = 0; i < functions.length; i++) {
      const message = functions[i](value, state);
      validation[field] = message;
      if (Boolean(message)) break;
    }
  });

  return validation;
}

export function useValidation(form, validators) {
  return useMemo(() => {
    const validation = validateForm(form, validators);
    const invalid = Object.values(validation).some((field) => Boolean(field));
    return [validation, invalid];
  }, [form, validators]);
}
